// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"abbc0e3ae9687e31d4df","149":"b887ec0010d506afc978"}[chunkId] + ".js";
};